import React from 'react';

import { Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { LogoBcp } from '@icons';

export const Logo: React.FC = () => {
	return (
		<Box
			styles={{
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<LogoBcp />
		</Box>
	);
};
